import styled, { css } from "styled-components";

export const Container = styled.div`
  flex: 1;
`;

export const styles = css`
  min-height: 40px;
  padding: 0 1rem;

  border-radius: 4px;
  border: 1px solid var(--input-border);

  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(3px);

  font-size: 1rem;
  color: var(--input-color);

  margin-top: 0.5rem;

  transition: 0.2s;

  font-family: var(--fontFamily);

  &:hover {
    border-color: var(--input-hover-border-color);
  }

  &:disabled,
  &.disabled {
    pointer-events: none;
    background-color: var(--input-disabled-background);
    border-color: var(--input-disabled-border) !important;

    &:hover {
      border-color: var(--input-disabled-border) !important;
    }
  }

  &:focus {
    box-shadow: var(--input-focus-shadow);
  }

  &.error {
    border-color: var(--input-error) !important;
  }

  &.validate {
    border-color: var(--input-success) !important;
  }

  &.verifying {
    border-color: var(--input-verifying) !important;
  }
`;

interface IProps {
  verifying?: boolean;
  error?: boolean;
  validate?: boolean;
}

export const Input = styled.input<IProps>`
  width: 100%;

  ${styles}
`;
